/**
 * Report event from the agent.
 *
 * {@link https://github.com/dotse/bredbandskollen/wiki/Bredbandskollen-API-v2#report-result}
 * {@link https://github.com/dotse/bredbandskollen/wiki/Agent-API-v2#the-report-event}
 */
export default function onReport(m, report) {
	if (!report.subscription || report.subscription.status !== 1) {
		console.warn('No subscription');
	}

	const { upload, latency, server_latency, subscription } = report;
	const updatedResult = {
		...m.data.result,
		upload: {
			...m.data.result.upload,
			result: upload,
		},
		latency: {
			...m.data.result.latency,
			result: server_latency !== undefined && server_latency !== null ? server_latency : latency,
		},
	};

	const infoMessage =
		subscription && subscription.status === 1
			? subscription.ispInfoMessage
			: null;

	const badMessage =
		subscription && subscription.status === 1
			? subscription.ispBadInfoMessage
			: null;

	m.setData({
		result: updatedResult,
		report,
		operatorInfoMessage: infoMessage || m.data.operatorInfoMessage,
		operatorBadInfoMessage: badMessage || m.data.operatorBadInfoMessage,
	});
}
